/* globals google */
export default function() {
	const { OverlayView, LatLng } = google.maps;
	const { addDomListener, trigger } = google.maps.event;

	class CssMarker extends OverlayView {
		constructor( options = {} ) {
			super();

			this.options_ = options;
			this.map_ = options.map;
			this.setPosition( options.position );
			var div = this.div_ = document.createElement( 'div' );

			div.className = this.options_.className || 'cssmarker';
			div.style.position = 'absolute';
			div.innerHTML = this.options_.contents ? this.options_.contents : '';

			addDomListener( div, 'click', () => {
				trigger( this, 'click' );
			} );

			this.setMap( options.map );
		}

		onAdd() {
			var panes = this.getPanes();
			panes.overlayMouseTarget.appendChild( this.div_ );
		}

		draw() {
			var projection = this.getProjection();

			if ( projection && this.position_ ) {
				var position = projection.fromLatLngToDivPixel( this.position_ );

				var div = this.div_;
				div.style.top = position.y + 'px';
				div.style.left = position.x + 'px';
			}
		}

		onRemove() {
			this.div_.parentNode.removeChild( this.div_ );
			this.div_ = null;
		}

		hide() {
			if ( this.div_ ) {
				this.div_.style.visibility = 'hidden';
			}
		}

		show() {
			if ( this.div_ ) {
				this.div_.style.visibility = 'visible';
			}
		}

		toggle() {
			if ( this.div_) {
				if ( this.div_.style.visibility === 'hidden' ) {
					this.show();
				} else {
					this.hide();
				}
			}
		}

		getPosition() {
			return this.position_;
		}

		setPosition( position ) {
			this.position_ = position;
			if ( ! ( position instanceof LatLng ) ) {
				this.position_ = new LatLng( position );
			}

			if ( this.div_ ) {
				this.draw();
			}
		}

		hasClass( name ) {
			return this.div_.classList.contains( name );
		}

		addClass( name ) {
			this.div_.classList.add( name );

			return this;
		}

		removeClass( name ) {
			this.div_.classList.remove( name );

			return this;
		}

		toggleClass( name, toggle ) {
			if ( this.hasClass( name ) || toggle === false ) {
				this.removeClass( name );
			} else if ( ! this.hasClass( name ) || toggle === true ) {
				this.addClass( name );
			}

			return this;
		}

		setVisible( visible ) {
			this.div_.style.visibility = visible ? 'inherit' : 'hidden';
		}

		setZIndex() {}
		setIcon() {}
	}

	return CssMarker;
}
